import { SearchInputStore } from 'ui/standard/input/search_input/search_input_store';
import { action, computed, observable } from 'mobx';
import { IssuesFilter, IssueKind } from 'services/pangolin/types';
import { createKindFilterOptions } from 'ui/issues/kind_entry/kind_entry_logic';
import { notUndefined } from 'ui/base/types';

export class KindInputStore {
  search: SearchInputStore;

  @observable.shallow entries: IssueKind[];
  @observable.shallow options: readonly IssueKind[];

  constructor(filter: IssuesFilter) {
    this.search = new SearchInputStore();

    const entries = filter.kinds;

    this.entries = entries;
    this.options = createKindFilterOptions(entries);
  }

  @action.bound
  commitEntry(entry: IssueKind): void {
    this.entries.push(entry);
  }

  @action.bound
  removeEntry(entry: IssueKind): void {
    const index = this.entries.findIndex(e => e === entry);
    if (index >= 0) {
      this.entries.splice(index, 1);
    }
  }

  @computed
  get kinds(): IssueKind[] {
    return this.entries.filter(notUndefined);
  }
}
